import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HOME_TABS = new Set(['/', '/art', '/about']);

/**
 * Resets window scroll on route pathname changes.
 * Home Work / Art / About tabs swap in-place, so those paths keep scroll.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    if (HOME_TABS.has(pathname)) return;
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}
